import { combineReducers } from 'redux';
import productModalReducer from './slices/productModalSlice';
import cartReducer from './slices/cartSlice';
import wishlistReducer from './slices/wishlistSlice';
import productReducer from './slices/productSlice';
import compareReducer from './slices/compareSlice';

const rootReducer = combineReducers({
  productModal: productModalReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  products: productReducer,
  compare: compareReducer,
});

export default rootReducer;
